import Nav from '../components/shared/Nav';
import Footer from '../components/shared/Footer';
import PVHero from '../components/pixviewer/PVHero';
import PVScreens from '../components/pixviewer/PVScreens';
import PVDemo from '../components/pixviewer/PVDemo';
import PVCloudFlow from '../components/pixviewer/PVCloudFlow';
import PVAndroid from '../components/pixviewer/PVAndroid';
import PVFaqCta from '../components/pixviewer/PVFaqCta';

export default function PixViewerPage() {
  return (
    <div data-screen-label="02 PixViewer">
      <Nav current="pixviewer" />
      <PVHero />
      <PVScreens />
      <PVDemo />
      <PVCloudFlow />
      <PVAndroid />
      <PVFaqCta />
      <Footer />
    </div>
  );
}
